import * as ProofOfWork from '../../../../common/request/types/proofOfWork';
import { ErrorCode } from '../interface';

// TODO : place holder for resources
export const VERIFYING_BOT_DISPLAY_TEXT = 'Making sure you are not a bot...';
export const VALIDATED_DISPLAY_TEXT = 'Completed';
export const INVALIDATED_DISPLAY_TEST = 'Not Validated';

// TODO: Add resource keys to `app.config.ts` as well.
export const getResources = () => ({
  Description: {
    VerifyingYouAreNotBot: 'Making sure you are not a bot...',
    ChallengeValidated: 'Challenge Completed',
    ChallengeInvalidated: 'Challenge Failed'
  }
});

export type ProofOfWorkResources = ReturnType<typeof getResources>;

export const mapProofOfWorkErrorToChallengeErrorCode = (
  error: ProofOfWork.ProofOfWorkError | null
): ErrorCode => {
  switch (error) {
    case ProofOfWork.ProofOfWorkError.SESSION_INACTIVE:
      return ErrorCode.SESSION_INVALID;
    default:
      return ErrorCode.UNKNOWN;
  }
};
